<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Rename Saved View</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form (submit)="handleSubmit()">

    <div class="modal-body">
      <div class="form-group">
        <label for="newName">Saved View Name</label>
        <input id="newName" type="text" class="form-control" name="newName"
               autocomplete="off"
               [(ngModel)]="newName">
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="genericErrorMessage">
        {{ genericErrorMessage }}
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary"
              (click)="activeModal.close()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary"
              *ngIf="!loadingSubmit">
        Save
      </button>
      <button type="button" class="btn btn-primary disabled" disabled
              *ngIf="loadingSubmit">
        Loading...
      </button>
    </div>

  </form>

</ng-container>
